import { FuelTag, FuelTooltip } from '@frete.com/fuel-react';
import React, { FC } from 'react';
import { formatTagText } from 'utils';

const Tag: FC<{ item: string; origin: string }> = ({ item, origin }) => {
  const { text, showTooltip } = formatTagText(item);

  const getCapitalizedText = (itemLower: string) => `${itemLower.charAt(0).toUpperCase()}${itemLower.slice(1)}`;

  if (showTooltip) {
    return (
      <FuelTooltip
        placement="top-start"
        content={item}
        data-testid={`test-${origin}-tooltip-${item.toLowerCase().replace(/ /g, '-')}`}
      >
        <FuelTag
          key={item}
          label={getCapitalizedText(text.toLowerCase())}
          uppercase={false}
          data-testid={`test-${origin}-tag-${item.toLowerCase().replace(/ /g, '-')}`}
        />
      </FuelTooltip>
    );
  }
  return (
    <FuelTag
      key={text}
      label={getCapitalizedText(item.toLowerCase())}
      uppercase={false}
      data-testid={`test-${origin}-tag-${item.toLowerCase().replace(/ /g, '-')}`}
    />
  );
};

export default Tag;
